import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        regions: string[]
      }
    }
  }
}

export default function regions(): Promise<string[]> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: { regions },
        },
      },
    }: Payload) => regions
  )
}

const query = gql`
  query regions {
    viewer {
      company {
        regions
      }
    }
  }
`
